import React from 'react'
import { Layout } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import LegalInfoModal from 'components/LegalInfoModal'
import SuperEgoLogo from 'components/SuperEgoLogo'
import { showLocaleModal } from 'redux/actions/settings'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import { getLocaleData } from 'locales/utils'
import { withSupportChat } from 'redux/enhancers'
import style from './style.module.scss'


class AirLayout extends React.Component {
  render() {
    const { intl: { formatMessage }, showLocaleModal, locale, showSupportChat, supportChatIsReady } = this.props;

    const languageName = getLocaleData(locale) ? formatMessage({ id: getLocaleData(locale).name }) : '';
    const flagSVG = getLocaleData(locale) ? getLocaleData(locale).flag : null;

    return (
      <Layout>
        <Layout.Content>
          <div className={style.layout}>
            <div className={style.header}>
              <div className={style.logo}>
                <SuperEgoLogo />
              </div>
            </div>
            <div className={style.content}>{this.props.children}</div>
            <div className={`${style.footer} text-center`}>
              <button
                onClick={showLocaleModal}
                className={style.changeLangButton}
                type="button"
              >
                {flagSVG && <div style={{ backgroundImage: `url(${flagSVG})` }} className={style.flagIcon} />}
                <span className={style.caption}>{languageName}</span>
                <CaretDownOutlined />
              </button>
              <p>
                &copy; {new Date().getFullYear()}, Super Ego.
                <LegalInfoModal />
                {supportChatIsReady &&
                  <button
                    type="button"
                    className={style.openSupportChatButton}
                    onClick={showSupportChat}
                  >
                    {formatMessage({ id: 'footer.show-support-chat-button' })}
                  </button>
                }
              </p>
            </div>
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default errorBoundaryEnhancer(
  connect(({ settings: { locale } }) => ({locale}), { showLocaleModal })
  (injectIntl(withSupportChat(AirLayout)))
)
